import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';

/**
 * ThemeToggle component - Simple button to toggle between light and dark themes
 *
 * Features:
 * - Shows Moon icon in light mode (suggests switching to dark)
 * - Shows Sun icon in dark mode (suggests switching to light)
 * - Matches sidebar button styling for consistency
 * - Accessible with proper ARIA labels
 * - Keyboard navigable
 */
export function ThemeToggle() {
  const { currentTheme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(currentTheme === 'dark' ? 'light' : 'dark');
  };

  const isDark = currentTheme === 'dark';
  const themeLabel = isDark ? 'Light' : 'Dark';
  const ariaLabel = `Switch to ${isDark ? 'light' : 'dark'} mode`;

  return (
    <button
      onClick={toggleTheme}
      className="w-full px-4 py-2 rounded-md bg-background text-foreground border border-border font-semibold hover:bg-muted transition-colors shadow-sm hover:shadow text-sm flex items-center justify-center gap-2"
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      {isDark ? (
        <Sun className="w-4 h-4 flex-shrink-0" />
      ) : (
        <Moon className="w-4 h-4 flex-shrink-0" />
      )}
      <span>{themeLabel} Mode</span>
    </button>
  );
}
